module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/PN-4e0d600c743d0e532a26ccbaf8db0c95.png";